<template>
  <div class="cs-studyAbroad-scoreList">
    <div>
      <span class="cs-title">{{dataIn.termName}}-{{titleText}}</span>
    </div>
    <pagination v-loading="loading" :data="listData" :option="paginationOption" @edit="edit">
    </pagination>
    <el-dialog :title="dialogTitle" center :close-on-click-modal="false" width="700px" :visible.sync="dialogEditorVisible" top="8vh">
      <scoreDetail :isReadonly="isReadonly" :scoreType="scoreType" :dataIn="editData" @closeDialog="onCloseEditor" @saveSuccess="onSaveSuccess">
      </scoreDetail>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.cs-studyAbroad-scoreList{
/deep/ .el-table th>.cell {
  word-break: break-word;
}
}
</style>

<script>
import pagination from "../../common/pagination";
import scoreDetail from "./scoreDetail";
import { getHomeworkList, getTranscriptList } from "../../../service/studyAbroad.service";
export default {
  props: {
    scoreType: {
      //1-学校作业, 2-学校成绩
      type: [Number, String],
      default: 1,
      validator: (value) => {
        let strValue = `${value}`;
        return ["1", "2"].contains(strValue);
      },
    },
    isReadonly: Boolean,
    dataIn:{
      termId: Number,
      termName: String,
      studentId: Number,
    }
  },
  data() {
    return {
      loading: false,
      listData: {},
      paginationOption: {},
      dialogEditorVisible: false,
      dialogTitle: "",
      titleText: "",
      editData:{}
    };
  },
  components: {
    pagination,
    scoreDetail,
  },
  created() {
    let btnText = "";
    if (this.scoreType == 1){
      btnText = "作业详情";
      this.dialogTitle = "学校作业详情";
      this.titleText = "学校作业信息";
    }else if (this.scoreType == 2){
      btnText = "成绩详情";
      this.dialogTitle = "学校成绩详情";
      this.titleText = "学校成绩信息";
    }
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: true,
      editButtonText: btnText,
      hasAddButton: false,
      hasSearch: false,
    };
    this.init();
  },
  methods: {
    init(){
      if (this.dataIn){
        this.loadData();
      }
    },
    onCloseEditor() {
      this.dialogEditorVisible = false;
    },
    loadData(){
      if (this.dataIn.termId && this.dataIn.studentId){
        this.loading = true;
        if (this.scoreType == 1){
          getHomeworkList(this.dataIn.termId, this.dataIn.studentId).then(result =>{
            if (result && result.success){
              this.listData = result.data;
            }
            this.loading = false;
          });
        }else if (this.scoreType == 2){
          getTranscriptList(this.dataIn.termId, this.dataIn.studentId).then(result =>{
            if (result && result.success){
              this.listData = result.data;
            }
            this.loading = false;
          });
        }else{
          this.loading = false;
        }
      }
    },
    onSaveSuccess(row) {
      this.loadData();
    },
    edit(index, row) {
      this.editData ={
        studentId: this.dataIn.studentId,
        courseId: row.CourseId,
        courseName: row.CourseName,
      };
      this.dialogEditorVisible = true;
    },
  },
  watch:{
    dataIn: function(){
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/academicInfo/scoreList.vue